module.exports = __webpack_public_path__ + "static/media/no-tests.f2bfe918.png";